import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      const token = localStorage.getItem('kopeng_token');
      const savedUser = localStorage.getItem('kopeng_user');
      if (token && savedUser) {
        try {
          setUser(JSON.parse(savedUser));
        } catch { /* ignore */ }
        // Refresh profile from API to get fresh data (e.g. telegram_chat_id)
        try {
          const { data } = await api.get('/auth/profile');
          setUser(data.user);
          localStorage.setItem('kopeng_user', JSON.stringify(data.user));
        } catch { /* ignore — use cached data */ }
      }
      setLoading(false);
    };
    init();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('kopeng_token', data.token);
    localStorage.setItem('kopeng_user', JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const register = async (formData) => {
    const { data } = await api.post('/auth/register', formData);
    localStorage.setItem('kopeng_token', data.token);
    localStorage.setItem('kopeng_user', JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('kopeng_token');
    localStorage.removeItem('kopeng_user');
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('kopeng_user', JSON.stringify(userData));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};
